module.exports = "/assets/85a84c9b37a840f6a5ac4bc662ab0962.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/SP.png
// module id = 2950
// module chunks = 0